import React from 'react';
import { Eye, BookOpen, LayoutGrid, Paintbrush, Type, Smile, ImageIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useEditorT } from '@i18n/editor';

export type MobileTool = 'preview' | 'cover' | 'layout' | 'background' | 'text' | 'stickers' | 'photos';

interface MobileToolbarProps {
  isCoverPage: boolean;
  onSelect: (tool: MobileTool) => void;
}

const MobileToolbar: React.FC<MobileToolbarProps> = ({ isCoverPage, onSelect }) => {
  const { te } = useEditorT();
  const tools: { id: MobileTool; icon: React.ReactNode; label: string; show: boolean }[] = [
    { id: 'photos', icon: <ImageIcon size={20} />, label: 'Photos', show: true },
    { id: 'cover', icon: <BookOpen size={20} />, label: 'Couv.', show: isCoverPage },
    { id: 'layout', icon: <LayoutGrid size={20} />, label: 'Modèles', show: !isCoverPage },
    { id: 'background', icon: <Paintbrush size={20} />, label: 'Fonds', show: true },
    { id: 'text', icon: <Type size={20} />, label: 'Texte', show: true },
    { id: 'stickers', icon: <Smile size={20} />, label: 'Stickers', show: true },
    { id: 'preview', icon: <Eye size={20} />, label: 'Aperçu', show: true },
  ];

  return (
    <nav
      aria-label={te("Outils de l’éditeur")}
      className="relative z-30 h-[calc(60px+env(safe-area-inset-bottom,0px))] shrink-0 bg-editor-sidebar border-t border-editor-sidebar-border flex items-stretch justify-around px-1 pb-[env(safe-area-inset-bottom,0px)]"
    >
      {tools.filter((t) => t.show).map((tool) => (
        <Button
          key={tool.id}
          variant="ghost"
          aria-label={te(tool.label)}
          onClick={() => onSelect(tool.id)}
          className="h-full min-w-0 flex-1 flex flex-col items-center justify-center gap-0.5 p-0 text-editor-sidebar-foreground/80 hover:text-editor-sidebar-foreground hover:bg-editor-sidebar-hover active:text-editor-sidebar-active active:bg-editor-sidebar-hover/50 transition-colors rounded-md [&_svg]:size-5"
        >
          {tool.icon}
          <span className="text-[9px] leading-none font-medium">{te(tool.label)}</span>
        </Button>
      ))}
    </nav>
  );
};

export default MobileToolbar;